module.exports = __webpack_public_path__ + "static/media/29ADMSPC7.6892ece6.jpg";